import React, { useState } from "react";
import {
    Select, MenuItem, FormControl, Box,
    RadioGroup, FormControlLabel, Radio,
    Typography
} from "@mui/material";
import TaskComponent from "../PolicyDetails/Task";

const GlobalTask = ({
    selected_customer_list,
    customerId
}) => {
    const [selectedPolicyId, setSelectedPolicyId] = useState("");
    const [selectedOption, setSelectedOption] = useState("All");

    const handleDropdownChange = (event) => {
        setSelectedPolicyId(event.target.value);
    };

    const handleRadioChange = (event) => {
        const newOption = event.target.value;
        setSelectedOption(newOption);

        // Reset selectedPolicyId when switching to "All"
        if (newOption === "All") {
            setSelectedPolicyId("");
        }
    };

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2,ml:3 }}>
                <RadioGroup
                    row
                    value={selectedOption}
                    onChange={handleRadioChange}
                >
                    <FormControlLabel value="All" control={<Radio />} label="All" />
                    <FormControlLabel value="Policies" control={<Radio />} label="Policies" />
                </RadioGroup>
            </Box>

            {selectedOption === "Policies" && (
            <Box sx={{ display: 'flex' }}>
                <FormControl fullWidth sx={{ mb: 2, width: '250px', ml: 3 }}>
                <Typography>Select Policy</Typography>
                <Select
                    value={selectedPolicyId || ""}
                    onChange={handleDropdownChange}
                    displayEmpty
                >
                    <MenuItem value="" disabled>
                    Select Policy
                    </MenuItem>

                    {selected_customer_list.map((policy) => (
                    <MenuItem key={policy.id} value={policy.id}>
                        {policy.policyNumber}
                    </MenuItem>
                    ))}
                </Select>
                </FormControl>
            </Box>
            )}

            <TaskComponent
                selectedOption={selectedOption}
                selectedPolicyId={selectedPolicyId}
                customerId={customerId}
                selected_customer_list={selected_customer_list}
            />
        </>
    );
}

export default GlobalTask;